/* eslint-disable no-sequences */
import {
  useContext, useState, useEffect, useRef,
} from 'react';
import {
  any, array, bool, node, object, string,
} from 'prop-types';
import { useRouter } from 'next/router';
import { UpOutlined } from '@ant-design/icons';
import Headroom from 'react-headroom';
import dynamic from 'next/dynamic';

import { CloseMdSVG } from 'components/iconsSVG/close';
import { Modal } from 'antd';
import { HeadSEO } from 'components/base';
import { MyAccountModal } from 'components/myAccount';
import Breadcrumb from 'components/breadcrumb';
import I18nModal from 'components/i18nModal';
import NewsletterModal from 'components/newsletterModal';
import EventsTwsModal from 'components/eventsTwsModal';
import GiftBagModal from 'components/giftBagModal';
import { MyOrderModal, GlobalEOrdersWidget } from 'components/myOrderModal';
import { i18nContext } from 'context/i18n';
import { userContext } from 'context/user';
import {
  DEFAULT_SEO, IS_CAMPER, IS_NNORMAL, TWS_MAGAZINES, TWS_MAGAZINE_LANGS, GLOBAL_E_SCRIPTS_ID,
} from 'utils/constants';
import {
  getLang, getMarket, getCookie, eraseCookie, getIsMobile, COOKIES,
  setCookie,
} from 'utils/helpers';
import { dataLayerHandleEvent } from 'utils/dataLayers';
import { hasToRenderGiftHat } from 'utils/nnormal';

import AbandonedCartBanner from 'components/abandonedCartBanner';
import SearchTNM from 'components/search';

import { findNode } from 'utils/array';
import styles from './style.module.css';

const Footer = IS_CAMPER ? dynamic(
  () => import('@camper/react-web-components').then((res) => res.ORGANISMS.Footer),
) : dynamic(
  () => import('@nnormal/react-web-components').then((res) => res.ORGANISMS.Footer),
);
const TnmComponent = IS_CAMPER ? dynamic(
  () => import('@camper/react-web-components').then((res) => res.ORGANISMS.TnmComponent),
) : dynamic(
  () => import('@nnormal/react-web-components').then((res) => res.ORGANISMS.TnmComponent),
);
const TnmNewComponent = IS_CAMPER ? dynamic(() => import('@camper/react-web-components').then((res) => res.ORGANISMS.TnmNewComponent)) : null;
const Ribbon = dynamic(() => import('components/ribbon'));
const ShoppingBag = dynamic(() => import('components/shoppingBag'));
const ShoppingBagNew = dynamic(() => import('components/shoppingBagNew'));
const MyAccountWidget = dynamic(() => import('components/myAccount'));
const MembersOnlyModal = dynamic(() => import('components/productPurchaseCol/membersOnlyModal'));

const widgetBagHidden = [
  // '/bolsa',
  '/compra',
];

const myOrderEvents = {
  account: {
    event: 'main_menu',
    event_category: 'menu',
    event_detail_1: 'my account',
    event_detail_2: 'orders',
  },
  tracking: {
    event: 'footer_menu',
    event_category: 'menu',
    event_detail_1: 'shopping on camper.com',
    event_detail_2: 'order tracking',
  },
};

function showNewTnmMobile(market) {
  if (!market) return false;
  return [
    'AT', 'PL', 'CH', 'IE', 'NL', 'XI', 'DK', 'FI', 'NO', 'SE', 'CA', 'HK', 'ES', 'PT', 'FR', 'MC', 'BE', 'IT', 'GR', 'SG', 'AD', 'CY', 'CZ', 'EE', 'LT', 'LU', 'MT', 'LV', 'RO', 'SI', 'SK', 'IL', 'AL', 'BR', 'OM', 'EC', 'ID', 'VN', 'MA', 'SA', 'PH', 'MY', 'EG', 'CR', 'DO', 'KW', 'MD', 'GT', 'VE', 'JO', 'NG', 'PA', 'BD', 'KE', 'BO', 'SV', 'SN', 'KH', 'LK', 'JM', 'BH', 'HN', 'TZ', 'PY', 'ET', 'BS', 'KY', 'BM', 'NI', 'NA', 'BW', 'AR', 'LB', 'AE', 'BA', 'IN', 'IS', 'LI', 'ZA', 'PG', 'BN', 'HU', 'BG', 'HR', 'QA', 'DZ', 'US', 'DE', 'GB' ].includes(market);
}
export default function Layout({
  children, footerProps, withFooter, withHead, tnmProps,
  breadcrumbs, breadcrumbsBottom, breadcrumbI18n, breadcrumbFragments,
  ribbon, metatags, extratags, camperlab, scrollArrow, idBag, pageName, translateSlug, recycled,
  isApp, gtmProps,
}) {
  const router = useRouter();
  const { pathname } = router;
  const isMobile = getIsMobile('768px');
  const {
    locale, countries, t, profileData, appmode,
    popupInfo,
  } = useContext(i18nContext);

  const { setAppliedVoucher } = useContext(userContext);
  const [ showingI18nModal, setShowingI18nModal ] = useState(false);
  const [ showingNewsletterModal, setShowingNewsletterModal ] = useState(false);
  const [ showingMyAccountModal, setShowingMyAccountModal ] = useState(false);
  const [ showingMyOrderModal, setShowingMyOrderModal ] = useState(false);
  const [ showingEventsTwsModal, setShowingEventsTwsModal ] = useState(false);
  const [ eventsTwsModalType, setEventsTwsModalType ] = useState('subscribe');
  const [ eventTwsEmail, setEventTwsEmail ] = useState('');
  const [ showingMembersOnlyModal, setShowingMembersOnlyModal ] = useState(false);
  const [ showingTnm, setShowingTnm ] = useState(false);
  const [ nlOrigin, setNLOrigin ] = useState('');
  const [ membersOnlyType, setMembersOnlyType ] = useState('ewallet');
  const [ membersOnlyHref, setMembersOnlyHref ] = useState('');
  const [ scrollArrowVisible, setScrollArrowVisible ] = useState(false);
  const [ showingRibbon, setShowingRibbon ] = useState(true);
  const [ userCS, setUserCS ] = useState(null);
  const [ visible, setVisible ] = useState(false);
  const [ urlBagRedirect, setUrlBagRedirect ] = useState(null);
  const [ showGiftBag, setShowGiftBag ] = useState(false);

  const [ showFooter, setShowFooter ] = useState(withFooter);
  const [ showHeader, setShowHeader ] = useState(withHead);
  const [ modalSource, setModalSource ] = useState(null);
  const [ modalSendUsrHash, setModalSendUsrHash ] = useState(null);

  const accountWidget = useRef(null);
  const currentBond = useRef(null);

  const market = getMarket(locale);
  const renderGifHat = hasToRenderGiftHat(t, market);

  const handleOpenNewsletterModal = (origin) => {
    // para cualquier check que tengamos que hacer
    // e.g. estoy logedo y ya estoy suscrito === no lo mostramos
    currentBond.current = getCookie(COOKIES.BONDS);
    const mutator = () => {
      setNLOrigin(origin);
      setShowingNewsletterModal(true);
    };

    mutator();
  };

  const isGlobalE = profileData.global_e;
  const isEsw = profileData?.esw === true;
  const regex2 = /^https?:\/\/[\w-]+(\.[\w-]+)+[/#?]?.*$/;

  if (isGlobalE) {
    let urlFAQ = footerProps?.menus?.[1]?.submenus[0]?.slug;

    if (urlFAQ) {
      urlFAQ = urlFAQ.replace(regex2, IS_CAMPER ? 'https://service.global-e.com/?id=82eb702a-cdc8-4401-92cf-b357fc6365ff&isPro=false' : 'https://service.global-e.com/?id=8DC7AD99-0A35-496A-9DDF-694A52C19769');

      footerProps.menus[1].submenus[0].slug = urlFAQ;
    }
    if (IS_NNORMAL) {
      let urlContact = findNode({ tree: footerProps?.menus, condition: (n) => n.slug?.endsWith(`/${locale}/contacto`), childrenKey: 'submenus' })?.slug;
      if (urlContact) {
        urlContact = urlContact.replace(regex2, 'https://service.global-e.com/?id=8DC7AD99-0A35-496A-9DDF-694A52C19769');
        findNode({ tree: footerProps?.menus, condition: (n) => n.slug?.endsWith(`/${locale}/contacto`), childrenKey: 'submenus' }).slug = urlContact;
      }
    }
  }

  if (locale.includes('JP')) {
    let urlFAQ = footerProps?.highlightMenus[0]?.link?.text;

    if (urlFAQ) {
      urlFAQ = urlFAQ.replace('Call us: -', 'Contact us:');

      footerProps.highlightMenus[0].link.text = urlFAQ;
    }
  }

  const handleChangeOrdersVisibility = (value, origin) => {
    setShowingMyOrderModal(value);

    if (origin) {
      const event = myOrderEvents[origin];

      if (event) {
        dataLayerHandleEvent(event);
      }
    }
  };

  const handleCloseNewsletterModal = () => {
    setShowingNewsletterModal(false);

    const bondCookie = getCookie(COOKIES.BONDS);

    if (bondCookie && bondCookie !== currentBond.current) {
      setAppliedVoucher(true);
    }
  };

  const onClickSignIn = () => {
    setShowingMyAccountModal(true);
  };

  useEffect(() => {
    if (window !== undefined) {
      setUserCS(getCookie(COOKIES.CS_EMPLOYEE_ID));
      window.openNewsletterModal = (source, sendUsrHash) => {
        if (source !== modalSource) {
          setModalSource(source);
        }

        if (sendUsrHash !== modalSendUsrHash) {
          setModalSendUsrHash(sendUsrHash);
        }

        handleOpenNewsletterModal(source || 'popup');
        // setNLOrigin('popup'); setShowingNewsletterModal(true);
      };

      window.sendDataLayer = (eventPayload) => {
        dataLayerHandleEvent(eventPayload);
      };

      window.showGiftBagPopUp = () => {
        if (IS_NNORMAL) {
          setShowGiftBag(renderGifHat);
        } else {
          setShowGiftBag(true);
        }
      };

      window.showEventsTwsModal = (id) => {
        setShowingEventsTwsModal(id);
      };
      window.showOrderPopUp = () => {
        setShowingMyOrderModal(true);
      };
      window.showMembersOnlyModal = (origin, popupType = '', href = '') => {
        let open = true;
        if (popupType.includes('magazine')) {
          const usrHash = getCookie(COOKIES.SELLIGENT_USRHASH);
          if (usrHash && usrHash !== '') {
            open = false;
            const lang = getLang(locale);
            const magazineType = popupType.split('-').pop();
            if (href && href?.length > 0) {
              window.location.assign(href);
            } else {
              window.open(TWS_MAGAZINES[magazineType in TWS_MAGAZINES ? magazineType : 'ibiza'].replace('LANG', TWS_MAGAZINE_LANGS.includes(lang) ? lang : 'en'), '_blank');
            }
          }
        }
        if (open) {
          setShowingMembersOnlyModal(true);
          setNLOrigin(origin || popupType);
          setMembersOnlyType(popupType);
          setMembersOnlyHref(href || '');
        }
      };

      window.onscroll = () => {
        const { y } = window.document.body.getBoundingClientRect();

        setScrollArrowVisible(y < -400);
        setShowingRibbon(y === 0);
      };

      const urlParams = new URLSearchParams(window.location.search);
      const eventId = urlParams.get('eventId');
      const email = urlParams.get('email');
      if (eventId && email) {
        setShowingEventsTwsModal(eventId);
        setEventsTwsModalType('unsubscribe');
        setEventTwsEmail(email);
      }
      if (eventId) {
        setShowingEventsTwsModal(eventId);
      }
      if (profileData.global_e) {
        const [ lang, country ] = [ getLang(locale), getMarket(locale) ];
        const { currency } = profileData;
        const data = {
          countryISO: country,
          currencyCode: currency,
          cultureCode: lang,
        };

        const GlobalE_Data = encodeURIComponent(JSON.stringify(data));

        setCookie(COOKIES.GLOBAL_E, GlobalE_Data, 1, COOKIES.DOMAIN);
      }
    }
  }, []);

  useEffect(() => {
    // para los países de globale accountWidget tiene que ser diferente solo en base a orders
    accountWidget.current = <MyAccountWidget onClickYourOrders={() => handleChangeOrdersVisibility(true, 'account')} onClickSignIn={onClickSignIn} />;

    if (isGlobalE || isEsw) {
      accountWidget.current = isMobile ? null : <GlobalEOrdersWidget onOpen={() => handleChangeOrdersVisibility(true, 'account')} onClose={() => handleChangeOrdersVisibility(false)} />;
    }
  }, [ isGlobalE, isEsw, isMobile ]);

  useEffect(() => {
    // tema appmode controlado 100% en _app.js
    setShowFooter(!appmode);
    setShowHeader(!appmode);
  }, [ appmode ]);

  const closeSession = () => {
    eraseCookie(COOKIES.CS_EMPLOYEE_ID);
    setUserCS(null);
  };
  const generatedURLBag = (id) => {
    setVisible(true);
    const url = `${window.location.origin}/${locale}/bolsa?hash=${id}`;
    setUrlBagRedirect(url);
  };

  const handleOnPinNav = () => {
    const filterNav = document.querySelector('#plp-filter-nav');
    const isDesktop = !(window.innerWidth < 1200);
    const tnmSelector = `.tnm--${isDesktop ? 'desktop' : 'mobile'}`;
    if (filterNav) {
      const tnmHeight = document.querySelector(tnmSelector).offsetHeight;
      filterNav.style.top = `${tnmHeight}px`;
      const filterPanel = document.querySelector('#plp-filter-panel');
      filterPanel.firstChild.style.top = `${filterNav.offsetHeight + tnmHeight}px`;
      filterPanel.firstChild.style.maxHeight = `calc(100vh - ${filterNav.offsetHeight + tnmHeight}px)`;
    }
    const stickyCol = document.querySelector('#sticky-col');
    if (stickyCol) {
      const tnmHeight = document.querySelector(tnmSelector).offsetHeight;
      stickyCol.style.top = `${tnmHeight}px`;
    }
    const landingSticky = document.querySelector('#landing-sticky');
    if (landingSticky) {
      const tnmHeight = document.querySelector(tnmSelector).offsetHeight;
      landingSticky.style.top = `${tnmHeight}px`;
    }
  };
  const handleOnUnpinNav = () => {
    const filterNav = document.querySelector('#plp-filter-nav');
    if (filterNav) {
      filterNav.style.top = '0px';
      const filterPanel = document.querySelector('#plp-filter-panel');
      filterPanel.firstChild.style.top = `${filterNav.offsetHeight}px`;
      filterPanel.firstChild.style.maxHeight = `calc(100vh - ${filterNav.offsetHeight}px)`;
    }
    const stickyCol = document.querySelector('#sticky-col');
    if (stickyCol) {
      stickyCol.style.top = '0px';
    }
    const landingSticky = document.querySelector('#landing-sticky');
    if (landingSticky) {
      landingSticky.style.top = '0px';
    }
  };
  const onTnmShow = () => {
    if (!showingTnm) {
      setShowingTnm(true);
    }
  };
  const onTnmHide = () => {
    setShowingTnm(false);
  };

  const scripts = [];

  if (profileData.global_e) {
    scripts.push(
      <script key="global-e-external" type="text/javascript" id="GlobalEScript" src={process.env.ENVIRONMENT === 'prod' ? `https://gepi.global-e.com/includes/js/${GLOBAL_E_SCRIPTS_ID}` : `https://intgepi.bglobale.com/includes/js/${GLOBAL_E_SCRIPTS_ID}`} defer />,
      <link id="GEPIStyles" key="global-e-css" rel="stylesheet" href={process.env.ENVIRONMENT === 'prod' ? `https://gepi.global-e.com/includes/css/${GLOBAL_E_SCRIPTS_ID}?countryCode=${getMarket(locale)}` : `https://intgepi.bglobale.com/includes/css/${GLOBAL_E_SCRIPTS_ID}?countryCode=${getMarket(locale)}`} />,
    );
  }

  let ordersWidget = <MyOrderModal
    locale={locale}
    visible={showingMyOrderModal}
    onClose={() => setShowingMyOrderModal(false)}
  />;

  if (isGlobalE || isEsw) {
    ordersWidget = <GlobalEOrdersWidget onOpen={() => setShowingMyOrderModal(true)} visible={showingMyOrderModal} onlyModal={true} onClose={() => setShowingMyOrderModal(false)} />;
  }

  const extraTags = [
    ...extratags,
  ];

  let layoutStyle = undefined;
  if (recycled) {
    layoutStyle = { '--background': 'var(--color-recycled)' };
  } else if (camperlab) {
    layoutStyle = { '--background': 'var(--color-camperlab)', '--font-primary': 'var(--font-camperlab)' };
  }

  return (
    <div
      className={styles.layout}
      data-camperlab={camperlab ? 'true' : undefined}
      style={layoutStyle}
    >
      {userCS &&
        <div className={styles.userCScontainer}>
          <img className={styles.infoCVC} src="/assets-new/account-trigger.svg" alt="Info" width={20} height={20}/>
          <span className={styles.userLine}> {userCS}</span>
          {idBag &&

            <a className={styles.userCSLink} onClick={() => generatedURLBag(idBag)}> generar URL</a>
          }

          <Modal
            visible={visible}
            title= {t('bolsa', 'url.customer.service', 'URL generada')}
            destroyOnClose={true}
            onCancel={() => setVisible(false)}
            closeIcon={<CloseMdSVG />}
            maskClosable={false}
            footer={null}
            closable={true}
          >

            <p>{urlBagRedirect}</p>

          </Modal>

          <a className={styles.userCSLink} onClick={() => closeSession()} > Close session</a>
        </div>
      }

      <HeadSEO
        title={metatags?.titlePage || DEFAULT_SEO.title}
        description={metatags?.metaDescription || DEFAULT_SEO.description}
        scripts={scripts}
        pageName={pageName}
        extraTags={extraTags}
        gtmProps={gtmProps}
      />
      {ribbon && ribbon.length > 0 && showHeader &&
        <Ribbon show={showingRibbon} items={ribbon} onClickNewsletter={() => {
          setModalSource('header');
          handleOpenNewsletterModal('header');
          // setNLOrigin('header'); setShowingNewsletterModal(true);
        } } />
      }
      { showHeader &&
      <header className={styles.headerNav}>
        {
          tnmProps &&
          <Headroom onPin={handleOnPinNav} onUnpin={handleOnUnpinNav}>
            {IS_CAMPER && showNewTnmMobile(market) ? ( // que si no TnmNewComponent es null
              <TnmNewComponent
                bagWidget={!widgetBagHidden.includes(pathname) ?
                  <>
                    { IS_CAMPER && process.env.ENVIRONMENT === 'integra' ? null : <ShoppingBag locale={locale} isInSalePath={pathname === '/bolsa'} /> }
                    { IS_CAMPER ? <ShoppingBagNew locale={locale} isInSalePath={pathname === '/bolsa'} /> : null }
                  </> :
                  null
                }
                onTnmShow={onTnmShow}
                onTnmHide={onTnmHide}
                showSearch={!IS_NNORMAL}
                searcher={<SearchTNM />}
                {...tnmProps}
                accountWidget={accountWidget.current}
                showI18nModal={() => setShowingI18nModal(true)}
                showNewsletterModal={() => {
                  handleOpenNewsletterModal('footer');
                  setNLOrigin('footer'); setShowingNewsletterModal(true);
                }}
                showOrderTrackingModal={() => setShowingMyOrderModal(true)}
              />
            ) : (
              <TnmComponent
                bagWidget={!widgetBagHidden.includes(pathname) ?
                  <>
                    { IS_CAMPER && process.env.ENVIRONMENT === 'integra' ? null : <ShoppingBag locale={locale} isInSalePath={pathname === '/bolsa'} /> }
                    { IS_CAMPER ? <ShoppingBagNew locale={locale} isInSalePath={pathname === '/bolsa'} /> : null }
                  </> :
                  null
                }
                onTnmShow={onTnmShow}
                onTnmHide={onTnmHide}
                showSearch={!IS_NNORMAL}
                searcher={<SearchTNM />}
                {...tnmProps}
                accountWidget={accountWidget.current}
                showI18nModal={() => setShowingI18nModal(true)}
                showNewsletterModal={() => {
                  handleOpenNewsletterModal('footer');
                  setNLOrigin('footer'); setShowingNewsletterModal(true);
                }}
                showOrderTrackingModal={() => setShowingMyOrderModal(true)}
              />
            )}
            <AbandonedCartBanner />
          </Headroom>
        }
      </header>
      }
      <div id="layoutContent" className={showingTnm ? `${styles.backdrop} ${styles.backdropVisible}` : styles.backdrop}>
        {breadcrumbs && !breadcrumbsBottom &&
          <Breadcrumb
            locale={locale}
            i18nKeys={breadcrumbI18n}
            camperlab={camperlab}
            fragments={breadcrumbFragments}
          />
        }
        {children}
        {breadcrumbs && breadcrumbsBottom &&
          <div className={styles.breadcrumbsBottom}>
            <Breadcrumb
              locale={locale}
              i18nKeys={breadcrumbI18n}
              camperlab={camperlab}
              fragments={breadcrumbFragments}
              pageName={pageName}
            />
          </div>
        }
        {showFooter && footerProps &&
          <>
            <Footer
              {...footerProps}
              showI18nModal={() => setShowingI18nModal(true)}
              showNewsletterModal={() => {
                setModalSource('footer');
                handleOpenNewsletterModal('footer');
                // setNLOrigin('footer'); setShowingNewsletterModal(true);
              }}

              showOrderTrackingModal={() => {
                handleChangeOrdersVisibility(true, 'tracking');
              }}
              newsletterTitle={popupInfo?.title || t('header.messages', `header.ribbon.01.${getMarket(locale)}.title`)}
              newsletterDescription={popupInfo?.text || t('header.messages', `header.ribbon.01.${getMarket(locale)}.text`)}
            />
            <I18nModal countries={countries} visible={showingI18nModal} changeVisibility={setShowingI18nModal} translateSlug={translateSlug} />
            <NewsletterModal
              countries={countries}
              locale={locale}
              visible={showingNewsletterModal}
              onClose={handleCloseNewsletterModal}
              nlOrigin={nlOrigin}
              pageName={pageName}
              source={modalSource}
              sendUsrHash={modalSendUsrHash}
              cmsProps={{
                newsletterPopup: footerProps.newsletterPopup,
                newsletterContent: footerProps.newsletterContent,
                newsletterPopupImages: footerProps.newsletterPopupImages,
              }}
              camperlab={camperlab}
            />
            <EventsTwsModal
              loading={false}
              id={showingEventsTwsModal === false ? '0' : showingEventsTwsModal}
              modalTwsVisible={showingEventsTwsModal !== false}
              setModalTwsVisible={setShowingEventsTwsModal}
              onFinishOk={() => console.log('ok')}
              type={eventsTwsModalType}
              email={eventTwsEmail}
            />
            <MembersOnlyModal
              loading={false}
              membersOnlyVisible={showingMembersOnlyModal}
              setModalMembersOnlyVisible={setShowingMembersOnlyModal}
              nlOrigin={nlOrigin}
              type={membersOnlyType}
              onFinishOk={() => console.log('ok')}
              href={membersOnlyHref}
            />
          </>
        }
        {
          scrollArrow && <button className={`${styles.scrollArrow} ${scrollArrowVisible ? '' : 'invisible'}`} onClick={() => {
            if (window && window.document) {
              const [ body ] = document.getElementsByTagName('body');

              if (body) {
                body.scrollIntoView({ behavior: 'smooth' });
              }
            }
          }}>
            <UpOutlined />
          </button>
        }
        <MyAccountModal locale={locale} visible={showingMyAccountModal} onClose={() => setShowingMyAccountModal(false)} />
        {ordersWidget}
      </div>
      <GiftBagModal
        visible={showGiftBag}
        onClose={() => setShowGiftBag(false)}
      />
    </div>
  );
}

Layout.propTypes = {
  children: node,
  footerProps: any,
  withFooter: bool,
  withHead: bool,
  tnmProps: any,
  breadcrumbs: bool,
  breadcrumbsBottom: bool,
  ribbon: array,
  metatags: object,
  extratags: array,
  camperlab: bool,
  recycled: bool,
  breadcrumbI18n: object,
  breadcrumbFragments: array,
  scrollArrow: bool,
  idBag: string,
  pageName: string,
  translateSlug: bool,
  isApp: bool,
  gtmProps: object,
};

Layout.defaultProps = {
  withFooter: true,
  withHead: true,
  breadcrumbs: true,
  breadcrumbsBottom: false,
  ribbon: [],
  metatags: null,
  extratags: [],
  camperlab: false,
  recycled: false,
  breadcrumbI18n: {},
  breadcrumbFragments: [],
  scrollArrow: false,
  idBag: null,
  pageName: null,
  translateSlug: false,
  isApp: false,
};
